import { render } from "./SideMenu.vue?vue&type=template&id=2ada8308"
const script = {}

import "./SideMenu.vue?vue&type=style&index=0&id=2ada8308&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__